exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-activity-icon{width:48px;height:48px;box-sizing:border-box;display:inline-block;box-shadow:inset 0 0 0 3px rgba(0,0,0,.03);-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.m-activity-icon svg{margin:12px}.m-activity-icon.is-orange{background-color:#ff8671}.m-activity-icon.is-noteYellow{background-color:#ffdc94}.m-activity-icon.is-green{background-color:#7ed321}.m-activity-icon.is-burgundy{background-color:#b52372}.m-activity-icon.is-yellow{background-color:#ffad40}.m-activity-icon.is-blue{background-color:#112363}", ""]);

// exports
